<div class="overlay-inner-wrapper">
  <div id="statisticsWrapper">
    <div class="clr-row">
      <div class="clr-col-12">
        <div class="text-left inline-block">
          <h3 class="mt-0">{{ 'Statistik' | mrTranslate }}</h3>
        </div>
        <div class="inline-block float-right">
          <cds-icon size="20" shape="times" (click)="close()" class="cursor-pointer" />
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-4">
        <clr-radio-container clrInline class="margin-0-t">
          <clr-radio-wrapper>
            <input type="radio" clrRadio [(ngModel)]="filterInspektion" [value]="1" />
            <label>{{ 'alle Inspektionen' | mrTranslate }}</label>
          </clr-radio-wrapper>
          <clr-radio-wrapper>
            <input type="radio" clrRadio [(ngModel)]="filterInspektion" [value]="0" />
            <label>{{ 'letzte Inspektion' | mrTranslate }}</label>
          </clr-radio-wrapper>
        </clr-radio-container>
        <div class="dateRow">
          <clr-date-container>
            <label for="dateInputStart">{{ 'Startdatum' | mrTranslate }}</label>
            <input
              id="dateInputStart"
              type="date"
              clrDate
              [ngModel]="filterDateStart | localeDate"
              (ngModelChange)="filterDateStart = localeDate.tosql($event)"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
          </clr-date-container>
          <clr-date-container>
            <label for="dateInputEnd">{{ 'Enddatum' | mrTranslate }}</label>
            <input
              id="dateInputEnd"
              type="date"
              clrDate
              [ngModel]="filterDateEnd | localeDate"
              (ngModelChange)="filterDateEnd = localeDate.tosql($event)"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
          </clr-date-container>
        </div>

        <clr-tree id="statisticSelection">
          @for (type of statisticsModes; track type) {
            <clr-tree-node>
              <cds-icon
                [shape]="'objekttyp' + type.icon"
                size="24"
                style="color: black; margin-right: 0.4em"></cds-icon>
              {{ type.bezeichnung | titlecase | mrTranslate }}
              @for (statMode of Object.keys(type.statistics); track statMode) {
                <clr-tree-node>
                  {{ statMode | titlecase | mrTranslate }}
                  @for (stat of type.statistics[statMode]; track stat) {
                    <clr-tree-node (click)="selectStatMode(type, statMode, stat)">
                      @if (isString(stat)) {
                        {{ stat | mrTranslate }}
                      } @else {
                        @if (stat?.name) {
                          <span>{{ stat.name | titlecase | mrTranslate }}</span>
                        }
                      }
                    </clr-tree-node>
                  }
                </clr-tree-node>
              }
            </clr-tree-node>
          }
        </clr-tree>
      </div>
      <div class="clr-col-8">
        <div id="statistikContent">
          <app-statistics-diagram
            [filterStartDate]="filterDateStart"
            [filterEndDate]="filterDateEnd"
            [allInspections]="filterInspektion == 1 ? true : false"
            [selectedMode]="selectedMode"></app-statistics-diagram>
        </div>
      </div>
    </div>
  </div>
</div>
